import * as React from 'react';

import classNames from 'classnames';

import s from './CaseFilter.module.scss';

export interface CaseCategoryItem {
    name: string;
    slug: string;
    pk: number;
};

export interface CaseFilterProps {
    categories: Array<CaseCategoryItem>;
    activeCategories: Array<string>;
    onFilterToggleButtonClick: Function;
};

const CaseFilter: React.FC<CaseFilterProps> = ({
    categories,
    activeCategories,
    onFilterToggleButtonClick
}) => {
    const allButtonClasses = classNames(s.FilterButton, {
        [s.FilterButtonActive]: activeCategories.length === 0
    });

    return (
        <div className={s.Root}>
            <button
                className={allButtonClasses}
                onClick={() => onFilterToggleButtonClick(null)}
            >
                Alla
            </button>

            {categories.map(category => {
                const buttonClasses = classNames(s.FilterButton, {
                    [s.FilterButtonActive]: activeCategories.indexOf(category.slug) > -1
                });

                return (
                    <button
                        key={category.pk}
                        className={buttonClasses}
                        onClick={() => onFilterToggleButtonClick(category.slug)}
                    >
                        {category.name}
                    </button>
                );
            })}
        </div>
    );
};

CaseFilter.defaultProps = {
    categories: [],
    activeCategories: [],
    onFilterToggleButtonClick: (v) => alert(v)
};

export default CaseFilter;
